<div>
    <h1>Content</h1>
    <p>Edit and manage all content across the workspace</p>
</div>
<div class="mat-elevation-z8">
    @if (isLoadingResults || isRateLimitReached) {
        <div class="example-loading-shade">
            @if (isLoadingResults) {
                <mat-spinner></mat-spinner>
            }
        </div>
    }

    @if (client$ | async; as client) {
        <div class="flex row flex-100">
            Currently utilizing {{ client.storage_use | bytes }} of storage
        </div>
    }

    <div class="example-table-container">
        <table
            mat-table
            [dataSource]="data"
            class="example-table"
            matSort
            matSortActive="created"
            matSortDisableClear
            matSortDirection="desc"
        >
            <ng-container matColumnDef="thumbnail">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let row">
                    <img src="{{ row.thumbnail }}" />
                </td>
            </ng-container>
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
                <td mat-cell *matCellDef="let row">
                    {{ row.name }}
                </td>
            </ng-container>
            <ng-container matColumnDef="author">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Author</th>
                <td mat-cell *matCellDef="let row">
                    {{ row.author.email }}
                </td>
            </ng-container>
            <ng-container matColumnDef="source_size">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Size</th>
                <td mat-cell *matCellDef="let row">
                    {{ row.source_size | bytes }}
                </td>
            </ng-container>
            <ng-container matColumnDef="views">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Views</th>
                <td mat-cell *matCellDef="let row">
                    {{ row.view_count }}
                </td>
            </ng-container>
            <ng-container matColumnDef="likes">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Likes</th>
                <td mat-cell *matCellDef="let row">
                    {{ row.like_count }}
                </td>
            </ng-container>
            <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
                <td mat-cell *matCellDef="let row">
                    <mat-icon>{{ IconMap.get(row.asset_type) }}</mat-icon>
                </td>
            </ng-container>
            <ng-container matColumnDef="hidden">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Hidden</th>
                <td mat-cell *matCellDef="let row">
                    <mat-checkbox
                        [checked]="row.hidden"
                        (change)="updateAsset(row, 'hidden', $event.checked)"
                    ></mat-checkbox>
                </td>
            </ng-container>
            <ng-container matColumnDef="deleted">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Deleted</th>
                <td mat-cell *matCellDef="let row">
                    <mat-checkbox
                        [checked]="row.deleted"
                        (change)="updateAsset(row, 'deleted', $event.checked)"
                    ></mat-checkbox>
                </td>
            </ng-container>
            <ng-container matColumnDef="modified">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Modified</th>
                <td mat-cell *matCellDef="let row">
                    {{ row.modified | date }}
                </td>
            </ng-container>
            <ng-container matColumnDef="created">
                <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Created</th>
                <td mat-cell *matCellDef="let row">
                    {{ row.created | date }}
                </td>
            </ng-container>
            <ng-container matColumnDef="history">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let row">
                    <button mat-icon-button [matMenuTriggerFor]="menu">
                        <mat-icon>more_horiz</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item (click)="viewAsset(row)">
                            <mat-icon>launch</mat-icon>
                            View Asset
                        </button>
                        <mat-divider></mat-divider>
                        <button mat-menu-item (click)="history(row)">
                            <mat-icon>history</mat-icon>
                            History
                        </button>
                        <button mat-menu-item (click)="streams(row)">
                            <mat-icon>water</mat-icon>
                            Streams
                        </button>
                        <frog-stream-move-menu
                            [copy]="true"
                            [assets]="[row]"
                        ></frog-stream-move-menu>
                        <mat-divider></mat-divider>
                        <button mat-menu-item (click)="delete(row)">
                            <mat-icon>delete</mat-icon>
                            Delete
                        </button>
                    </mat-menu>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
    </div>

    <mat-paginator [length]="resultsLength" [pageSize]="9 * 8"></mat-paginator>
</div>
